export const NoResponse = 'NoResponse';
export const Accepted = 'Accepted';
export const Declined = 'Declined';
export const Visited = 'Visited';
export const Waitlisted = 'Waitlisted';
export const Cancelled = 'Cancelled';
export const PendingApproval = 'PendingApproval';
export const DeniedApproval = 'DeniedApproval';
